// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {
  position: fixed;
  top: 1.25rem; 
  left: 50%; 
  transform: translateX(-50%); 
  background-color: #636963a8; 
  color: white; 
  padding: 0.5rem 1rem; 
  border-radius: 0.375rem; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  z-index: 1000; 
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Popup/Popup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;AACf","sourcesContent":[".toast {\n  position: fixed;\n  top: 1.25rem; \n  left: 50%; \n  transform: translateX(-50%); \n  background-color: #636963a8; \n  color: white; \n  padding: 0.5rem 1rem; \n  border-radius: 0.375rem; \n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); \n  z-index: 1000; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
